import { fmt } from './calc';

export function buildLeaveBehind(v) {
	const esc = (s) =>
		String(s === null || s === undefined ? '' : s)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	const fld = (id) => {
		const el = document.getElementById(id);
		return (el ? el.value : el) ? el.value : '';
	};
	const company = fld('company') || '[CONFIDENTIAL]';
	const repname = fld('repname') || '[Rep Name]';
	const repphone = fld('repphone') || '[Phone]';
	const repemail = fld('repemail') || '[Email]';
	const year = new Date().getFullYear();
	const state = v.state;
	const naicsLabel = (v.naics || '').replace(/\s+\(proxy rate\)$/, '');

	const cell = (l, val, sub, cls) =>
		'<td class="c ' +
		(cls || '') +
		'"><div class="c-l">' +
		esc(l) +
		'</div>' +
		'<div class="c-v">' +
		esc(val) +
		'</div>' +
		(sub ? '<div class="c-s">' + esc(sub) + '</div>' : '') +
		'</td>';

	const hasDisp = v.displaced > 0;
	const roi = [
		['FLEX INVESTMENT', fmt(v.flex), ''],
		hasDisp
			? [
					'DISPLACED SOFTWARE SPEND',
					fmt(v.displaced),
					'Current tools Flex replaces',
				]
			: null,
		['ANNUAL SAVINGS', fmt(v.annSavings), ''],
		['Y1 NET VALUE', fmt(v.y1Net), ''],
		['Y2 NET VALUE', fmt(v.yrTwoNet), ''],
	].filter(Boolean);

	const facts = [
		['INDUSTRY', v.sector],
		['SUB-INDUSTRY', naicsLabel],
		['STATE', state],
		['ANNUAL PAYROLL', fmt(v.payroll)],
		['TRIR', v.trirLabel],
		['EMPLOYEES', v.employeesLabel],
	];

	// Static approved customer references. Marketing owns this content -
	// confirm both references are still cleared for external use before sending.
	const TESTIMONIALS = [
		{
			sector: 'CONSTRUCTION',
			quote: 'We\u2019ve actually cut our recordable injuries in half.',
			who: 'Sam Erickson \u00b7 Corporate Safety Officer',
			org: 'Quality Electric Inc.',
			result: '\u2193 50% recordable injuries, Year 1',
		},
		{
			sector: 'ENERGY / INDUSTRIAL',
			quote: 'The downtime Novara has saved us is astronomical.',
			who: 'Jason Zemer \u00b7 EHS Coordinator',
			org: 'Burleson Sand Mine',
			result: '\u2193 Ex-mod 1.23 \u2192 0.95 \u00b7 Claims cost down significantly',
		},
	];

	const compare = [
		[
			'Risk data scattered across sites and systems',
			'Unified risk intelligence across all locations',
		],
		[
			'Incident reporting manual and inconsistent',
			'Standardized workflows, configured to your operation',
		],
		[
			'Compliance managed reactively, after the fact',
			'Proactive risk intelligence in real time',
		],
		[
			'Limited executive visibility into trends',
			'Dashboard clarity for leadership at every level',
		],
	];

	const recon = hasDisp
		? '<div class="note">Y1 Net Value = annual savings ' +
			fmt(v.annSavings) +
			' + displaced software spend ' +
			fmt(v.displaced) +
			' &minus; Flex investment ' +
			fmt(v.flex) +
			'. Displaced spend is credited at full value each year and is not escalated.</div>'
		: '';
	const basis =
		'<div class="note">Loss cost basis: ' +
		esc(v.lcBasis) +
		(v.lcExact
			? ''
			: ' &mdash; proxy rate, not a ' + esc(state) + '-specific filing') +
		'.</div>';

	return (
		'<!DOCTYPE html><html lang="en"><head><meta charset="utf-8">' +
		'<title>Novara - Risk Exposure Summary - ' +
		esc(company) +
		'</title><style>' +
		'@page{size:letter;margin:0}' +
		'body{margin:0;padding:0;font-family:Arial,Helvetica,sans-serif;color:#1A0A2E;background:#fff;' +
		'-webkit-print-color-adjust:exact;print-color-adjust:exact}' +
		'table{border-collapse:separate;width:100%}' +
		'.wrap{width:950px;margin:0 auto}' +
		'.hd{background:#2A1148;background-image:linear-gradient(100deg,#1A0A2E 0%,#3D1A72 52%,#B3312B 100%);color:#fff;padding:24px 34px}' +
		'.logo{font-size:26px;font-weight:700;letter-spacing:6px;color:#fff}' +
		'.hd-r{text-align:right;font-size:13px;color:#fff}' +
		'.hd-s{font-size:11px;color:#BCAFD0;padding-top:4px}' +
		'.pad{padding:24px 34px 0}' +
		'.h1{font-size:29px;font-weight:700}.h1 i{color:#B3312B;font-style:normal}' +
		'.lede{font-size:14px;color:#3A3355;padding-top:8px}' +
		'.band{background:#F2F0F6;padding:18px 34px;margin-top:20px}' +
		'.facts{border-spacing:0;table-layout:fixed}' +
		'.facts td{vertical-align:top;padding:0 10px 12px 0;border-bottom:1px solid #CFC9DE}' +
		'.f-l{font-size:9px;letter-spacing:1.1px;color:#6B6385;font-weight:700}' +
		'.f-v{font-size:12.5px;padding-top:5px;line-height:1.35}' +
		'.h2{font-size:15px;font-weight:700;padding:16px 0 9px}' +
		'.g{border-spacing:8px 0;margin-left:-8px;width:calc(100% + 16px)}' +
		'.c{background:#fff;border:1px solid #D8D4EC;border-top:3px solid #3D1A72;' +
		'border-radius:6px;padding:12px 14px;vertical-align:top}' +
		'.c.red{background:#8E2A24;border-color:#8E2A24;border-top-color:#8E2A24}' +
		'.c.roi{border-top-color:#B3312B;padding:10px 12px}' +
		'.c-l{font-size:8.5px;letter-spacing:1.1px;font-weight:700;color:#8E2A24}' +
		'.c.red .c-l{color:#F3D5D3}' +
		'.c-v{font-size:22px;font-weight:700;padding:5px 0 3px;color:#1A0A2E}' +
		'.c.red .c-v{color:#fff}.c.roi .c-v{font-size:17px}' +
		'.c-s{font-size:9px;color:#6B6385}.c.red .c-s{color:#EBC9C6}' +
		'.note{font-size:9px;color:#5E5678;padding-top:7px;line-height:1.5}' +
		'.nim{background:#fff;border:1px solid #D8D4EC;border-radius:6px;margin-top:9px;border-spacing:0}' +
		'.nim td{padding:11px 14px;font-size:10.5px;color:#3A3355;vertical-align:middle}' +
		'.nim-l{font-size:8.5px;font-weight:700;letter-spacing:1px;color:#8E2A24;width:78px;line-height:1.4}' +
		'.cmp{border-spacing:0 6px;margin-top:2px}' +
		'.cmp th{font-size:8.5px;letter-spacing:1.1px;color:#6B6385;font-weight:700;text-align:left;padding-bottom:2px}' +
		'.cmp td{vertical-align:middle}' +
		'.old{background:#F2F0F6;font-size:11.5px;padding:9px 11px;border-radius:4px;color:#1A0A2E}' +
		'.arw{width:30px;padding:0 6px}' +
		'.arwb{background:#B3312B;height:15px;border-radius:3px;font-size:1px;line-height:15px;color:#B3312B}' +
		'.new{background:#1A0A2E;color:#fff;font-size:11.5px;padding:9px 11px;border-radius:4px}' +
		'.tq{background:#2A1148;background-image:linear-gradient(120deg,#2A1148 0%,#3D1A72 60%,#8E2A24 100%);' +
		'border-radius:6px;padding:14px 16px;color:#fff;vertical-align:top;width:50%}' +
		'.tq-t{font-size:8.5px;letter-spacing:1.1px;font-weight:700;color:#D9C9E8}' +
		'.tq-q{font-size:13px;font-style:italic;font-weight:700;padding:12px 0 10px;line-height:1.4}' +
		'.tq-w{font-size:9.5px;color:#CBBBDD;line-height:1.5}' +
		'.tq-r{font-size:10px;font-weight:700;border-top:1px solid rgba(255,255,255,.35);margin-top:10px;padding-top:8px}' +
		'.ft{background:#140820;background-image:linear-gradient(100deg,#140820 0%,#241038 70%,#3A1440 100%);color:#fff;padding:20px 34px;margin-top:20px}' +
		'.ft-h{font-size:16px;font-weight:700;color:#fff}' +
		'.ft-p{font-size:11px;color:#B0A4C4;padding-top:6px;line-height:1.5}' +
		'.ft-r{text-align:right;font-size:11px;color:#fff;line-height:1.7;white-space:nowrap;vertical-align:bottom}' +
		'.qr{width:66px;height:66px;border:1px dashed #6A5A80;border-radius:4px;color:#8A7BA0;' +
		'font-size:8px;text-align:center;line-height:66px}' +
		'</style></head><body><div class="wrap">' +
		'<table class="hd"><tr><td class="logo">NOVARA</td>' +
		'<td class="hd-r">Prepared for &nbsp;<b>' +
		esc(company) +
		'</b>' +
		'<div class="hd-s">' +
		year +
		' Proposal &nbsp;&middot;&nbsp; Confidential</div></td></tr></table>' +
		'<div class="pad"><div class="h1">The cost of your current <i>risk exposure</i>.</div>' +
		'<div class="lede">With Novara, you can materially reduce risk and achieve meaningful cost savings.</div></div>' +
		'<div class="band">' +
		'<table class="facts">' +
		'<colgroup><col style="width:14%"><col style="width:30%"><col style="width:8%">' +
		'<col style="width:18%"><col style="width:9%"><col style="width:13%"></colgroup><tr>' +
		facts
			.map(
				(f) =>
					'<td><div class="f-l">' +
					esc(f[0]) +
					'</div><div class="f-v">' +
					esc(f[1]) +
					'</div></td>'
			)
			.join('') +
		'</tr></table>' +
		'<div class="h2">Your current annual exposure</div>' +
		'<table class="g"><tr>' +
		cell(
			'WORKERS\u2019 COMP PREMIUM',
			fmt(v.wcCurrent),
			'Payroll \u00d7 loss cost \u00d7 experience mod'
		) +
		cell(
			'INJURY COSTS (DIRECT + INDIRECT)',
			fmt(v.injTotal),
			'Includes 2.1\u00d7 indirect multiplier'
		) +
		cell(
			'TOTAL ANNUAL EXPOSURE',
			fmt(v.totalExp),
			'What your operation absorbs today',
			'red'
		) +
		'</tr></table>' +
		'<table class="g" style="margin-top:9px"><tr>' +
		roi.map((r) => cell(r[0], r[1], r[2], 'roi')).join('') +
		'</tr></table>' +
		recon +
		basis +
		'<table class="nim"><tr><td class="nim-l">NOT IN<br>THIS MODEL</td>' +
		'<td>Regulatory penalties and enforcement actions</td>' +
		'<td>Administrative time absorbed each incident cycle</td>' +
		'<td>Compliance gaps that compound over time</td></tr></table></div>' +
		'<div class="pad"><div class="h2">Today vs. with Flex</div>' +
		'<table class="cmp"><tr><th>TODAY</th><th class="arw"></th><th>WITH FLEX</th></tr>' +
		compare
			.map(
				(r) =>
					'<tr><td class="old">' +
					esc(r[0]) +
					'</td>' +
					'<td class="arw"><div class="arwb">&nbsp;</div></td>' +
					'<td class="new">' +
					esc(r[1]) +
					'</td></tr>'
			)
			.join('') +
		'</table>' +
		'<div class="h2">What customers have seen</div>' +
		'<table class="g" style="margin-left:-8px"><tr>' +
		TESTIMONIALS.map(function (x) {
			return (
				'<td class="tq">' +
				'<div class="tq-t">' +
				esc(x.sector) +
				'</div>' +
				'<div class="tq-q">\u201c' +
				esc(x.quote) +
				'\u201d</div>' +
				'<div class="tq-w">' +
				esc(x.who) +
				'<br>' +
				esc(x.org) +
				'</div>' +
				'<div class="tq-r">' +
				esc(x.result) +
				'</div></td>'
			);
		}).join('') +
		'</tr></table></div>' +
		'<table class="ft"><tr><td>' +
		'<div class="ft-h">Let\u2019s talk about what this means for ' +
		esc(company) +
		'</div>' +
		'<div class="ft-p">Schedule an executive briefing \u2014 30 minutes,<br>your operation, your numbers.</div></td>' +
		'<td class="ft-r">' +
		esc(repname) +
		'<br>' +
		esc(repphone) +
		'<br>' +
		esc(repemail) +
		'<br><b>novara.com</b></td>' +
		'<td style="width:80px;vertical-align:bottom"><div class="qr">QR</div></td></tr></table>' +
		'</div></body></html>'
	);
}

export function exportLeaveBehind(values) {
	if (!values) {
		// eslint-disable-next-line no-alert -- kept from the original calculator; only reachable before a valid calculation.
		alert(
			'Complete the calculator first \u2014 sector, state, industry, employees and salary are all required.'
		);
		return;
	}
	const html = buildLeaveBehind(values);
	const el = document.getElementById('company');
	const co =
		((el ? el.value : el) || 'prospect')
			.replace(/[^A-Za-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '')
			.slice(0, 40) || 'prospect';
	const stamp = new Date().toISOString().slice(0, 10);
	const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = 'Novara-Risk-Exposure-' + co + '-' + stamp + '.html';
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	setTimeout(function () {
		URL.revokeObjectURL(url);
	}, 4000);
}
